import React, { useState, useEffect } from "react";
import { Modal, Button, Input, Typography } from "antd";
import axios from "axios";

const { Text } = Typography;

const verificationTimeout = 180;

const TwoFAVerifyModal = ({ isVisible, handleVerify2FA, setShow2FAVerifyModal, message }) => {
  const [countdown, setCountdown] = useState(verificationTimeout);
  const [code, setCode] = useState("");

  useEffect(() => {
    if (isVisible) {
      setCountdown(verificationTimeout);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isVisible]);

  const onCheckCode = () => {
    axios.post("/api/auth/verify2FA", { code }).then((response) => {
      handleVerify2FA(response.data.success);
    });
  };

  const onCancel = () => {
    setShow2FAVerifyModal(false);
  };

  return (
    <Modal
      title="SMS Doğrulama"
      maskClosable={false}
      closable={false}
      open={isVisible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Vazgeç
        </Button>,
        <Button
          key="verify"
          type="primary"
          onClick={onCheckCode}
          disabled={countdown === 0}
        >
          Doğrula
        </Button>,
      ]}
    >
      <Text type="secondary">{message}</Text>
      <Input
        placeholder="Doğrulama kodunu giriniz..."
        value={code}
        onChange={(e) => setCode(e.target.value)}
        maxLength={6}
        pattern="\d*"
      />
      <Text type="warning">Kalan süre: {countdown} saniye</Text>
    </Modal>
  );
};

export default TwoFAVerifyModal;
